import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { ExpandSingle, Header3 } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import { hoursFormatted } from "~/utils/utils.jsx";

export const TimeRecordTotalExpand = ({
  onChangeExpand,
  showExpandSingle,
  loggedUserTotal,
  total,
  limitedAccessCount,
  othersUserTotal,
}) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const handleClick = useCallback(() => {
    const newShow = !show;
    if (typeof onChangeExpand === "function") {
      onChangeExpand(newShow);
    }
    setShow(newShow);
  }, [onChangeExpand, show]);

  return (
    <div
      className={classnames("tw-self-end", "tw-inline-flex", "tw-items-center", {
        "tw-cursor-pointer tw-absolute tw-right-0 tw-hidden sm:tw-flex": showExpandSingle,
      })}
      onClick={handleClick}
    >
      {showExpandSingle && (
        <ExpandSingle
          className="tw-text-primary tw-mr-1"
          expanded={show}
        />
      )}

      {limitedAccessCount <= 0 && loggedUserTotal === total ? (
        <Header3
          tabularNums
          align="left"
          color="theme-secondary"
          weight="bold"
        >
          {t("Total")}: {hoursFormatted({ hours: 0, minutes: total }, false, true)}h
        </Header3>
      ) : null}
      {loggedUserTotal > 0 && (limitedAccessCount > 0 || loggedUserTotal !== total) ? (
        <Header3
          tabularNums
          align="left"
          color="theme-secondary"
          weight="bold"
          className="tw-mr-2"
        >
          {t("You")}: {hoursFormatted({ hours: 0, minutes: loggedUserTotal }, false, true)}
          h,
        </Header3>
      ) : null}
      {limitedAccessCount > 0 || loggedUserTotal !== total ? (
        <Header3
          tabularNums
          align="right"
          color="theme-secondary"
        >
          {t("Others")}: {hoursFormatted({ hours: 0, minutes: othersUserTotal }, false, true)}h
        </Header3>
      ) : null}
    </div>
  );
};

TimeRecordTotalExpand.propTypes = {
  onChangeExpand: PropTypes.func,
  showExpandSingle: PropTypes.bool,
  total: PropTypes.number,
  loggedUserTotal: PropTypes.number,
  othersUserTotal: PropTypes.number,
  limitedAccessCount: PropTypes.number,
};

TimeRecordTotalExpand.defaultProps = {
  showExpandSingle: true,
  total: 0,
  loggedUserTotal: 0,
  othersUserTotal: 0,
  limitedAccessCount: 0,
};
